<template>
    <div class="grid grid-cols-2 gap-4">
        <div class="col-span-2 sm:col-span-2 mb-3">
            <input type="file" ref="picture" style="display:none" @change="handlePicture" />
            <div class="flex items-center justify-center space-x-2">
                <div class="relative w-28 h-28 rounded-full cursor-pointer flex items-center justify-center bg-sky-light">
                    <PictureAvatarUser :user="user" :currentPicture="currentPicture" />
                    <div @click="$refs.picture.click()" style="top:5.5rem" class="absolute z-20 bg-white text-center right-2
                        justify-center items-center flex rounded-full shadow p-4 w-6 h-6 border border-gray-200"
                    >
                        <i v-if="form.photo" class="fad fa-pencil text-xs"></i>
                        <i v-else class="fad fa-image text-xs"></i>
                    </div>
                </div>
            </div>
            <JetInputError :message="form.errors.photo"/>
        </div>
        <div class="col-span-2 sm:col-span-2">
            <JetLabel for="name" value="Nom & prénom(s):" />
            <JetInput id="name" type="text" v-model="form.name" maxlength="80"
                placeholder="Entrer nom & prénom(s)" autocomplete="off"
            />
            <JetInputError :message="form.errors.name" />
        </div>
        <div class="col-span-2 sm:col-span-2">
            <JetLabel for="email" value="Adresse mail:" />
            <JetInput id="email" type="email" v-model="form.email"
                maxlength="80" placeholder="Entrer adresse mail" autocomplete="off"
            />
            <JetInputError :message="form.errors.email" />
        </div>
        <div class="col-span-2 sm:col-span-2">
            <JetLabel for="phone" value="Téléphone:" />
            <vue-tel-input required @input="phoneInput"
                :defaultCountry="form.country_code" :value="form.phone"
            />
            <JetInputError :message="form.errors.phone" />
        </div>
        <div class="col-span-2 sm:col-span-2">
            <JetLabel for="role" value="Rôle:" />
            <select v-model="form.role" class="form-input w-full uppercase">
                <option value="null" disabled selected hidden>Choisissez le rôle</option>
                <option v-for="(role, index) in roles" :key="index" :value="role['value']">
                    {{ role['description'] }}
                </option>
            </select>
            <JetInputError :message="form.errors.role" />
        </div>
        <div class="col-span-2 sm:col-span-2">
           <boti-button :loader="form.processing" :disabled="form.processing"
                @click="updateProfilInfos" class="w-full" color="sky"
                :class="{ 'opacity-25': form.processing }" text="Mettre à jour"
            >
                <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                    <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                </svg>
                <template #icon>
                    <i class="fad fa-check-circle text-xs ml-1"></i>
                </template>
            </boti-button>
        </div>
    </div>
</template>

<script>
    import JetLabel from '@/Jetstream/Label'
    import JetInput from '@/Jetstream/Input'
    import BotiButton from '@/Components/Button'
    import JetInputError from '@/Jetstream/InputError'
    import RebuildPhoneMixins from '@/Mixins/RebuildPhoneMixins'
    import PictureAvatarUser from '@/Components/PictureAvatarUser'
    import PicturesActionsMixins from '@/Mixins/PicturesActionsMixins'
    
    export default {
        props: {
            user: Object,
            roles: Array
        },

        mixins: [RebuildPhoneMixins, PicturesActionsMixins],

        data() {
            return {
                form: this.$inertia.form({
                    photo: null,
                    name: this.user.name,
                    email: this.user.email,
                    role: this.user.role,
                    phone: this.user.phone,
                    dial_code: this.user.dial_code,
                    country_code: this.user.country_code,
                })
            }
        },

        components: {
            JetLabel,
            JetInput,
            BotiButton,
            JetInputError,
            PictureAvatarUser
        },

        mounted() {
            console.log(this.user.profile_photo_url)
        },

        methods: {

            updateProfilInfos() {
                this.form.post(route('users.update', this.user), {
                    preserveScroll: true,
                    onSuccess: () =>{
                        this.$swal.fire(
                            'Utilisateur',
                            'Utilisateur mis à jour avec succès.',
                            'success'
                        )
                    },
                })
            }
        }
    }
</script>
